import { connect } from 'react-redux';
import { IMyWorkTopBarEvents } from '../../components/MyWorkTopBar/types';
import { onBackClick } from './events/onBackClick';
import { ChatViewTopBar } from '../../components/ChatViewTopBar/ChatViewTopBar';

const mapDispatchToProps = (
    dispatch: any
): IMyWorkTopBarEvents => {
    return {
        onBackClick: () => dispatch(onBackClick())
    }
};

export const ChatViewTopBarHOC = connect(
    null,
    mapDispatchToProps
)(ChatViewTopBar);

ChatViewTopBarHOC.displayName = 'ChatViewTopBarHOC';
